/**
 * Brazilian Portuguese (pt-BR) mappings for ChatHistoryPanel
 * Simple key-value pairs for easy maintenance
 */

export const chatHistoryPanelPtBR = {
  // Main UI elements
  "Chat history": "Histórico de chat",
  "New chat": "Nova conversa",
  "Search": "Buscar"
};